import { http } from '@/core/api/';
import DocumentsService from '@/services/documents';

const apiUrl = 'api/report';
export default {
  /*
    model { regStudentId, evaluationDateId, isInitial }
  */
  async downloadEE06(model) {
    const { data: document } = await this.getEE06(model);
    DocumentsService.Download(document);
  },

  /**
   * @model { regStudentId, evaluationDateId, isInitial, placementCommitteeId }
   */
  async getEE06(model) {
    return await http.get(
      `${apiUrl}/EE06/${model.regStudentId}/${model.placementCommitteeId}`
    );
  },

  async downloadEE05(regStudentId, isInitial, regStudentPostRegistryId) {
    regStudentPostRegistryId = regStudentPostRegistryId ?? 0;
    const { data: document } = await http.get(
      `${apiUrl}/EE05/${regStudentId}/${isInitial}/${regStudentPostRegistryId}`
    );
    DocumentsService.Download(document);
  },

  async downloadEE05V3(studentSieId, placementCommitteId) {
    const { data: document } = await http.get(
      `${apiUrl}/EligibilityDeterminationReport/${studentSieId}/${placementCommitteId}`
    );
    DocumentsService.Download(document);
  },

  async downloadVaccinationCertification(studentSieId) {
    await http
      .get(`${apiUrl}/vaccinationcertification/${studentSieId}`)
      .then((data) => {
        DocumentsService.Download(data);
      });
  },

  async downloadTransportation(peiId, analysisServiceId) {
    await http
      .get(`${apiUrl}/transportation/${peiId}/${analysisServiceId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadTransportationAEE(peiId, analysisServiceId) {
    await http
      .get(`${apiUrl}/transportationaee/${peiId}/${analysisServiceId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadReferralReport(studentReferralId) {
    await http
      .get(`${apiUrl}/referral/referralreport/${studentReferralId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadReferralReportFromStudentService(studentServiceId) {
    await http
      .get(`${apiUrl}/studentservice/referralreport/${studentServiceId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadMultipleReferralReports(peiId) {
    await http
      .get(`${apiUrl}/pei/referralreport/multiple/${peiId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async getLatestSignedPeipReport(studentSieId) {
    await http
      .get(`${apiUrl}/latestsignedpeipreport?studentSieId=${studentSieId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },
  /**
   * description: download a report after assigning turn and downloading the therapy with no funds available
   * @model: { peiId, disciplineTypeCd, assignedTurn }
   */
  async downloadnotfundsavailable(model) {
    return await http
      .get(
        `${apiUrl}/downloadnotfundsavailable?peiId=${model.peiId}&disciplineTypeCd=${model.disciplineTypeCd}&assignedTurn=${model.assignedTurn}`
      )
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadSieReplace(studentToDelete) {
    return await http
      .get(`${apiUrl}/sieReplace/${studentToDelete}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadSaee10(academicYearId) {
    return await http
      .get(`${apiUrl}/saee10List/${academicYearId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadStudentAcademicProgress(peiAcademicProgressId) {
    return await http
      .get(
        `${apiUrl}/studentsbyprogressacademicyearreport/${peiAcademicProgressId}`
      )
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadWeeklycompliance(model) {
    return await http
      .get(`${apiUrl}/getweeklycompliance`, {
        params: model,
      })
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadMultipleSaee03cReports(studentEvaluationIds) {
    await http
      .post(`${apiUrl}/saee-03c`, studentEvaluationIds)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async downloadSaee12a(id) {
    await http.get(`${apiUrl}/saee-12a/${id}`).then(({ data }) => {
      DocumentsService.Download(data);
    });
  },

  async downloadSaee12(id) {
    await http.get(`${apiUrl}/saee-12/${id}`).then(({ data }) => {
      DocumentsService.Download(data);
    });
  },

  async downloadSaee12b(model) {
    await http
      .get(`${apiUrl}/saee-12b/`, {
        params: model,
      })
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async getUserQueuedReport(reportTypeId) {
    return await http.get(`${apiUrl}/getuserqueuedreport/${reportTypeId}`);
  },

  async downloadQueuedReport(executionLogId) {
    return await http
      .get(`${apiUrl}/downloadqueuedreport/${executionLogId}`)
      .then(({ data: response }) => {
        DocumentsService.Download(response);
      });
  },

  async cancelQueuedReport(executionLogId) {
    return await http.get(`${apiUrl}/cancelqueuedreport/${executionLogId}`);
  },

  async queueSaee10Report(params) {
    return await http.get(`${apiUrl}/queuesaee10report`, {
      params,
    });
  },

  async downloadEquipmentUsageGuaranteeDocument(model) {
    await http
      .get(`${apiUrl}/equipmentusageguaranteedocument/`, {
        params: model,
      })
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },
  async downloadChildCountCertification(params) {
    const { data } = await http.get(`${apiUrl}/childcountcertification/`, {
      params,
    });
    DocumentsService.Download(data);
  },
  async downloadWorkshopCertificate(id) {
    const { data } = await http.get(`${apiUrl}/workshopcertificate/${id}`);
    DocumentsService.Download(data);
  },
  async downloadWorkshopParticipants(id) {
    const { data } = await http.get(`${apiUrl}/workshop/${id}/participants`);
    DocumentsService.Download(data);
  },
  async getActionPlanReport(params) {
    const { data } = await http.get(`${apiUrl}/actionplan`, { params });
    DocumentsService.Download(data);
  },
  async downloadCertificationDiscipline(params) {
    const { data } = await http.get(`${apiUrl}/certificationdiscipline/`, {
      params,
    });
    DocumentsService.Download(data);
  },
  async downloadCertificationEgress(params) {
    const { data } = await http.get(`${apiUrl}/certificationegress/`, {
      params,
    });
    DocumentsService.Download(data);
  },
  async getMedicalPlanConsent(id) {
    const { data } = await http.get(`${apiUrl}/medicalplanconsent/${id}`);
    DocumentsService.Download(data);
  },
  async downloadWorkshopParticipantAnswers(id) {
    const { data } = await http.get(
      `${apiUrl}/workshop/${id}/participantanswers`
    );
    DocumentsService.Download(data);
  },
  async getCompuMeetingCoordination(studentSieId, citationNumber) {
    const { data } = await http.get(
      `${apiUrl}/compuappointment/meetingcoordination`,
      {
        params: { studentSieId, citationNumber },
      }
    );
    DocumentsService.Download(data);
  },
};
